

<ng-container *ngIf="!equipmentProviderInActive">
    <div id="topHeader" class="forHeader {{activeTemplate}} header header_desktop" *ngIf="breakpoints.large || breakpoints.extraLarge"
   [ngClass]="{ extra: searchBox }">
   <div class="flex-row a-items-center p-y-lg-smaller border-bottom" [ngClass]="{ extra: searchBox }">
       <a [routerLink]="['/']">
           <div class="{{activeTemplate}} header__logo">
               <!-- <img src="../../../assets/images/iCreditHeaderLogo.png" alt="iCreditHeaderLogo" /> -->
               <img [src]="sharedDataService.assetsCdn('images/iCreditWorks Point of Care Lending@3x.png')"
                   alt="iCreditHeaderLogo" alt="" loading="lazy" />
           </div>
       </a>
       <!-- <ejs-dropdownlist #search id='search_list' class="header__search search-field" [dataSource]='searchData' [allowFiltering]='true' [ngStyle]="{'visibility': searchVisibility, 'height': searchHeight }" [ignoreAccent]='true' placeholder='Search icreditworks.' (change)="searchChange()" [fields]='fields'
       [popupHeight]='searchPopupHeight' filterBarPlaceholder='e.g: faq' (beforeOpen)='dropDownOpen($event)' (close)='dropDownClose($event)'>
       </ejs-dropdownlist> -->
       <app-header-search style="z-index: 100" class="header__search search-field" *ngIf="searchBox"
           [dataSource]="searchData" [fields]="fields" (closeEvent)="closeEvent()"
           [searchBox]="searchBox"></app-header-search>
       <div class="blockHeaderSearch m-l-auto h-fit" [ngClass]="{ 'display-none': searchBox }">
           <ul class="header__navigation font-big" [ngClass]="{ 'display-none': !displayNavigation }">
               <li class="header__link" (click)="page.scrollTo('contact_us')">
                   <a [routerLink]="['/policies']" [state]="{ to: 'contact_us' }"> Contact Us </a>
               </li>
               <!-- <li class="header__link" (click)="toggleChat()">Chat</li> -->
               <li class="header__link" (click)="page.scrollTo('faq')"><a [routerLink]="['/policies']">FAQ</a>
               </li>
               <li class="header__link" [class.header__link_login]="showLoginOptions">
                   <div style="position: relative">
                       <a skipLocationChange (click)="clickLogin()" class="link_login_inactive"
                           [class.link_login_active]="showAccountText || showLoginOptions"
                           *ngIf="!showLogoutText">
                           {{ showAccountText ? 'My Account' : 'Login' }}
                       </a>
                       <a skipLocationChange *ngIf="showLoginOptions" (click)="toggleConsumerLogin()"
                           class="{{activeTemplate}} link_login link_consumer">Consumer</a>
                       <a *ngIf="showLoginOptions" target="_blank" [href]="providerUrl"
                           class="{{activeTemplate}}  link_login link_provider">Provider</a>
                       <a class="{{activeTemplate}} link_login_active" role="button" skipLocationChange *ngIf="showLogoutText"
                           (click)="clickLogout()">
                           Log Out
                       </a>
                   </div>
               </li>
               <li class="header__link searchLi" (click)="toggleSearch()">
                   <span class="search__icon"><img [src]="sharedDataService.assetsCdn('images/search-copy.svg')" alt="search"
                           alt="" loading="lazy" /></span>
               </li>
           </ul>
       </div>
   </div>
   <div class="d-flex">
       <ul *ngIf="showBottomLinks" class="header__navigation font-small p-y-lg-small"
           [ngClass]="{ 'o-0': searchBox }">
           <li class="header__link small" *ngFor="let page of pages">
               <a [routerLink]="modPageUri(page.uri)" routerLinkActive="font-weight-bold"
                   [routerLinkActiveOptions]="{ exact: true }">{{ page.title }}</a>
           </li>
           <!-- <li class="header__link small">
               <a [routerLink]="routeAccountValidation" routerLinkActive="font-weight-bold"
                   [routerLinkActiveOptions]="{ exact: true }">Join as a Provider</a>
                  -->
                <!--  Already Commented -->
                <!-- <a [routerLink]="captureRoute ? 'hsfs/hsfs-account-activation': 'account-activation'" routerLinkActive="font-weight-bold" [routerLinkActiveOptions]="{ exact: true }">Join as a Provider</a> -->
                <!-- <a routerLink={{routeAccountValidation}} routerLinkActive="font-weight-bold" [routerLinkActiveOptions]="{ exact: true }">Join as a Provider</a> -->
                <!------------>
           <!-- </li> -->
       </ul>
   </div>
   <!-- <ejs-dropdownlist #search id='search_list' [dataSource]='searchData' [allowFiltering]='true' [ngStyle]="{'visibility': searchVisibility, 'height': searchHeight }" [ignoreAccent]='true' placeholder='Select a value' (change)="searchChange()" [fields]='fields'
   [popupHeight]='searchPopupHeight' filterBarPlaceholder='e.g: faq'>
   </ejs-dropdownlist> -->
   <div class="wrapper_gray" *ngIf="searchBox" (click)="toggleSearch()"></div>
   </div>
   
   <ng-container *ngIf="breakpoints.extraSmall">
   <div class="{{activeTemplate}}  header header_mobile" id="mobileHeader">
       <div class="header__row">
           <div id="nav__toggler" (click)="toggleNav()">
               <span></span>
               <span></span>
               <span></span>
               <span></span>
           </div>
           <div class="header__logo m-x-auto p-y-xs-regular p-y-lg-medium">
               <a [routerLink]="['/']">
                    <!-- <img src="../../../assets/dental/images/iCreditHeaderLogo.png" alt="iCreditHeaderLogo" />  -->
                 <img [src]="sharedDataService.assetsCdn('images/iCreditWorks Point of Care Lending@3x.png')"
                       alt="iCreditHeaderLogo" class="logo_mobile_img" loading="lazy" /> 
               </a>
           </div>
           <a class="question_button" (click)="page.scrollTo('faq')" [routerLink]="['/policies']">
               <img class="header__info" [ngClass]="showNav ? 'opacity-0' : 'opacity-1'"
                   [src]="sharedDataService.assetsCdn('images/icon-question-mark-dark-blue.svg')" alt="help" alt=""
                   loading="lazy" />
           </a>
       </div>
       <div class="border" *ngIf="!showNav"></div>
       <div class="sidebar sidebar_collapsed" id="sidebar" *ngIf="showNav">
           <div class="searchbar p-b-small " [class.mob-search-bar]="isDropdownActive">
               <!-- <input type="text" class="header__search" placeholder="Search icreditworks.com" /> -->
               <!-- <ejs-dropdownlist #search id="search_list" [dataSource]="searchDataMob" [allowFiltering]="true"
                   [ignoreAccent]="true" class="header__search" placeholder="Search icreditworks.com"
                   [fields]="fields" [popupHeight]="searchMobilePopupHeight" filterBarPlaceholder="e.g: faq"
                   (change)="searchMobileChange()"></ejs-dropdownlist> -->
             <ng-select class="{{activeTemplate}} search-dropdown" #searchDropdown [items]="searchDataMob" bindLabel="Text" bindValue="URL"
                groupBy="Category" [searchable]="true" [openOnEnter]="true" [placeholder]="dropdownPlaceholder"
                [inputAttrs]="searchInputAttrs" (focus)="onDropdownFocus()" (open)="onOpen()" (close)="onClose()"
                (change)="searchMobileChange($event)">
            </ng-select>

           </div>
           <div class="border"></div>
           <ul class="header__navigation">
               <li class="header__link header__link_primary">
                   <span (click)="dropdownToggle($event)">Overview<span class="m-l-auto"><i
                               class=" arrow arrow_down"></i></span></span>
                   <ul class="header__navigation header__navigation_hidden">
                       <li class="header__link header__link_secondary" (click)="page.scrollTo('loanOptions')">
                           <a [routerLink]="['/']" [state]="{ to: 'loanOptions' }">Check loan options</a>
                       </li>
                       <li class="header__link header__link_secondary"
                           (click)="page.scrollTo('simplePayments')">
                           <a [routerLink]="['/']" [state]="{ to: 'simplePayments' }">Simple payments</a>
                       </li>
                       <li class="header__link header__link_secondary" (click)="page.scrollTo('partners')">
                           <a [routerLink]="['/']" [state]="{ to: 'partners' }">iCreditWorks partners</a>
                       </li>
                   </ul>
               </li>
               <li class="header__link header__link_primary">
                   <span (click)="dropdownToggle($event)">Why iCreditWorks<span class="m-l-auto"><i
                               class=" arrow arrow_down"></i></span></span>
                   <ul class="header__navigation header__navigation_hidden">
                       <li class="header__link header__link_secondary" (click)="page.scrollTo('')">
                           <a [routerLink]="['/why-us']">The care you deserve</a>
                       </li>
                       <li class="header__link header__link_secondary"
                           (click)="page.scrollTo('communityFeedback')">
                           <a [routerLink]="['/why-us']" [state]="{ to: 'communityFeedback' }">Community
                               feedback</a>
                       </li>
                       <li class="header__link header__link_secondary"
                           (click)="page.scrollTo('videosContainer')">
                           <a [routerLink]="['/why-us']" [state]="{ to: 'videosContainer' }">How-to-videos</a>
                       </li>
                   </ul>
               </li>
               <li class="header__link header__link_primary">
                   <span (click)="dropdownToggle($event)">Experience<span class="m-l-auto"><i
                               class=" arrow arrow_down"></i></span></span>
                   <ul class="header__navigation header__navigation_hidden">
                       <li class=" header__link header__link_secondary" (click)="page.scrollTo('')">
                           <a [routerLink]="['/credit-tools']">An awesome new app</a>
                       </li>
                       <li class="header__link header__link_secondary" (click)="page.scrollTo('appProccess')">
                           <a [routerLink]="['/credit-tools']" [state]="{ to: 'appProccess' }">Simple
                               application process</a>
                       </li>
                       <li class="header__link header__link_secondary" (click)="page.scrollTo('creditTools')">
                           <a [routerLink]="['/credit-tools']" [state]="{ to: 'creditTools' }">Credit tools</a>
                       </li>
                   </ul>
               </li>
               <!-- <li class="header__link header__link_primary" (click)="toggleNav();"
                   [routerLink]="[routeAccountValidation]">Join as a Provider</li> -->
                <!-- <li class="header__link header__link_primary" (click)="toggleChat()">Chat</li> -->
               <li class="header__link header__link_primary"
                   (click)="toggleNav(); page.goAndScroll('/policies', 'faq')">
                   <a>FAQ</a>
               </li>
               <li class="header__link header__link_primary" (click)="toggleNav(); page.scrollTo('lets_chat')"
                   [routerLink]="['/policies']" [state]="{ to: 'lets_chat' }">
                   <a>Help</a>
               </li>
           </ul>
       </div>
   </div>
   </ng-container>
</ng-container>




<ng-container *ngIf="equipmentProviderInActive">

    <div id="topHeader" class="forHeader {{activeTemplate}} header header_desktop" *ngIf="breakpoints.large || breakpoints.extraLarge"
    [ngClass]="{ extra: searchBox }">
    <div class="flex-row a-items-center p-y-lg-smaller border-bottom" [ngClass]="{ extra: searchBox }">
        <a [routerLink]="['/']">
            <!-- <div class="{{activeTemplate}} header__logo" style="padding-left: 1.5rem;"> -->
            <div class="{{activeTemplate}} header__logo" >
                <!-- <img src="../../../assets/images/iCreditHeaderLogo.png" alt="iCreditHeaderLogo" /> -->
                <!-- <img [src]="sharedDataService.assetsCdn('images/practicepaylogo.webp')"
                    style="width: 200px;height: 48.498px"  alt="iCreditHeaderLogo" alt="" loading="lazy" /> -->
                 <img [src]="sharedDataService.assetsCdn('images/PracticePay logo_FINAL_medium gray Works_8.14.2025.svg')"
                    style="width: 185px;height: 60.498px"  alt="iCreditHeaderLogo" alt="" loading="lazy" />
                </div>
        </a>
        <!-- <ejs-dropdownlist #search id='search_list' class="header__search search-field" [dataSource]='searchData' [allowFiltering]='true' [ngStyle]="{'visibility': searchVisibility, 'height': searchHeight }" [ignoreAccent]='true' placeholder='Search icreditworks.' (change)="searchChange()" [fields]='fields'
        [popupHeight]='searchPopupHeight' filterBarPlaceholder='e.g: faq' (beforeOpen)='dropDownOpen($event)' (close)='dropDownClose($event)'>
        </ejs-dropdownlist> -->
        <app-header-search style="z-index: 100" class="header__search search-field" *ngIf="searchBox"
            [dataSource]="searchData" [fields]="fields" (closeEvent)="closeEvent()"
            [searchBox]="searchBox"></app-header-search>
        <div class="blockHeaderSearch m-l-auto h-fit" [ngClass]="{ 'display-none': searchBox }">
            <ul class="header__navigation font-big" [ngClass]="{ 'display-none': !displayNavigation }">
                <li class="header__link" (click)="page.scrollTo('contact_us')">
                    <a [routerLink]="['/policies']" [state]="{ to: 'contact_us' }"> Contact Us </a>
                </li>
                <!-- <li class="header__link" (click)="toggleChat()">Chat</li> -->
                <li class="header__link" (click)="page.scrollTo('faq')"><a [routerLink]="['/policies']">FAQ</a>
                </li>
                <li class="header__link" [class.header__link_login]="showLoginOptions">
                    <div style="position: relative">
                        <a skipLocationChange (click)="toggleConsumerLogin()" class="link_login_inactive"
                            [class.link_login_active]="showAccountText || showLoginOptions"
                            *ngIf="!showLogoutText">
                            {{ showAccountText ? 'My Account' : 'Login' }}
                        </a>
                        <!-- <a skipLocationChange *ngIf="showLoginOptions" (click)="toggleConsumerLogin()"
                            class="{{activeTemplate}} link_login link_consumer">Consumer</a>
                        <a *ngIf="showLoginOptions" target="_blank" [href]="providerUrl"
                            class="{{activeTemplate}}  link_login link_provider">Provider</a> -->
                        <a class="{{activeTemplate}} link_login_active" role="button" skipLocationChange *ngIf="showLogoutText"
                            (click)="clickLogout()">
                            Log Out
                        </a>
                    </div>
                </li>
                <li class="header__link searchLi" (click)="toggleSearch()">
                    <span class="search__icon"><img [src]="sharedDataService.assetsCdn('images/search-copy.svg')" alt="search"
                            alt="" loading="lazy" /></span>
                </li>
            </ul>
        </div>
    </div>
    <!-- <div class="d-flex">
        <ul *ngIf="showBottomLinks" class="header__navigation font-small p-y-lg-small"
            [ngClass]="{ 'o-0': searchBox }">
            <li class="header__link small" *ngFor="let page of pages">
                <a [routerLink]="modPageUri(page.uri)" routerLinkActive="font-weight-bold"
                    [routerLinkActiveOptions]="{ exact: true }">{{ page.title }}</a>
            </li>
            <li class="header__link small">
                <a [routerLink]="routeAccountValidation" routerLinkActive="font-weight-bold"
                    [routerLinkActiveOptions]="{ exact: true }">Join as a Provider</a>
    
              </li>
        </ul>
    </div>  -->
    <!-- <ejs-dropdownlist #search id='search_list' [dataSource]='searchData' [allowFiltering]='true' [ngStyle]="{'visibility': searchVisibility, 'height': searchHeight }" [ignoreAccent]='true' placeholder='Select a value' (change)="searchChange()" [fields]='fields'
    [popupHeight]='searchPopupHeight' filterBarPlaceholder='e.g: faq'>
    </ejs-dropdownlist> -->
    <div class="wrapper_gray" *ngIf="searchBox" (click)="toggleSearch()"></div>
    </div>
    
    <ng-container *ngIf="breakpoints.extraSmall">
    <div class="{{activeTemplate}} header header_mobile" id="mobileHeader">
        <div class="header__row">
            <div id="nav__toggler" (click)="toggleNav()">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="header__logo m-x-auto p-y-xs-regular p-y-lg-medium">
                <a [routerLink]="['/']">
                    <!-- <img src="../../../assets/images/iCreditHeaderLogo.png" alt="iCreditHeaderLogo" /> -->
                    <img [src]="sharedDataService.assetsCdn('images/iCreditWorks Point of Care Lending@3x.png')"
                        alt="iCreditHeaderLogo" class="logo_mobile_img" loading="lazy" />
                </a>
            </div>
            <a class="question_button" (click)="page.scrollTo('faq')" [routerLink]="['/policies']">
                <img class="header__info" [ngClass]="showNav ? 'opacity-0' : 'opacity-1'"
                    [src]="sharedDataService.assetsCdn('images/icon-question-mark-dark-blue.svg')" alt="help" alt=""
                    loading="lazy" />
            </a>
        </div>
        <div class="border" *ngIf="!showNav"></div>
        <div class="sidebar sidebar_collapsed" id="sidebar" *ngIf="showNav">
            <div class="searchbar p-b-small"  [class.mob-search-bar]="isDropdownActive">
                <!-- <ejs-dropdownlist #search id="search_list" [dataSource]="searchDataMob" [allowFiltering]="true"
                    [ignoreAccent]="true" class="header__search" placeholder="Search icreditworks.com"
                    [fields]="fields" [popupHeight]="searchMobilePopupHeight" filterBarPlaceholder="e.g: faq"
                    (change)="searchMobileChange()"></ejs-dropdownlist> -->
                    <ng-select class="{{activeTemplate}} search-dropdown" #searchDropdown [items]="searchDataMob" bindLabel="Text" bindValue="URL"
                        groupBy="Category" [searchable]="true" [openOnEnter]="true" [placeholder]="dropdownPlaceholder"
                        [inputAttrs]="searchInputAttrs" (focus)="onDropdownFocus()" (open)="onOpen()" (close)="onClose()"
                        (change)="searchMobileChange($event)">
                    </ng-select>
            </div>
            <div class="border"></div>
            <ul class="header__navigation">
                <li class="header__link header__link_primary">
                    <span (click)="dropdownToggle($event)">Overview<span class="m-l-auto"><i
                                class=" arrow arrow_down"></i></span></span>
                    <ul class="header__navigation header__navigation_hidden">
                        <li class="header__link header__link_secondary" (click)="page.scrollTo('loanOptions')">
                            <a [routerLink]="['/']" [state]="{ to: 'loanOptions' }">Check loan options</a>
                        </li>
                        <li class="header__link header__link_secondary"
                            (click)="page.scrollTo('simplePayments')">
                            <a [routerLink]="['/']" [state]="{ to: 'simplePayments' }">Simple payments</a>
                        </li>
                        <li class="header__link header__link_secondary" (click)="page.scrollTo('partners')">
                            <a [routerLink]="['/']" [state]="{ to: 'partners' }">iCreditWorks partners</a>
                        </li>
                    </ul>
                </li>
                <li class="header__link header__link_primary">
                    <span (click)="dropdownToggle($event)">Why iCreditWorks<span class="m-l-auto"><i
                                class=" arrow arrow_down"></i></span></span>
                    <ul class="header__navigation header__navigation_hidden">
                        <li class="header__link header__link_secondary" (click)="page.scrollTo('')">
                            <a [routerLink]="['/why-us']">The care you deserve</a>
                        </li>
                        <li class="header__link header__link_secondary"
                            (click)="page.scrollTo('communityFeedback')">
                            <a [routerLink]="['/why-us']" [state]="{ to: 'communityFeedback' }">Community
                                feedback</a>
                        </li>
                        <li class="header__link header__link_secondary"
                            (click)="page.scrollTo('videosContainer')">
                            <a [routerLink]="['/why-us']" [state]="{ to: 'videosContainer' }">How-to-videos</a>
                        </li>
                    </ul>
                </li>
                <li class="header__link header__link_primary">
                    <span (click)="dropdownToggle($event)">Experience<span class="m-l-auto"><i
                                class=" arrow arrow_down"></i></span></span>
                    <ul class="header__navigation header__navigation_hidden">
                        <li class=" header__link header__link_secondary" (click)="page.scrollTo('')">
                            <a [routerLink]="['/credit-tools']">An awesome new app</a>
                        </li>
                        <li class="header__link header__link_secondary" (click)="page.scrollTo('appProccess')">
                            <a [routerLink]="['/credit-tools']" [state]="{ to: 'appProccess' }">Simple
                                application process</a>
                        </li>
                        <li class="header__link header__link_secondary" (click)="page.scrollTo('creditTools')">
                            <a [routerLink]="['/credit-tools']" [state]="{ to: 'creditTools' }">Credit tools</a>
                        </li>
                    </ul>
                </li>
                <!-- <li class="header__link header__link_primary" (click)="toggleNav();"
                    [routerLink]="[routeAccountValidation]">Join as a Provider</li> -->
                <li class="header__link header__link_primary"
                    (click)="toggleNav(); page.goAndScroll('/policies', 'faq')">
                    <a>FAQ</a>
                </li>
                <li class="header__link header__link_primary" (click)="toggleNav(); page.scrollTo('lets_chat')"
                    [routerLink]="['/policies']" [state]="{ to: 'lets_chat' }">
                    <a>Help</a>
                </li>
            </ul>
        </div>
    </div>
    </ng-container>
   </ng-container>
   